// Llaves de caché de las lecturas de Cobranza.

/** El listado de Cobranza: cada cuota trae el bloqueo de su equipo. */
export const INSTALLMENTS_LIST_KEY = ['credit-installments'] as const;

/** Los mensajes enviados de un crédito, por páginas. */
export const CREDIT_NOTIFICATIONS_KEY = ['credit-notifications'] as const;
